// src/components/HowItWorks.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Image, Button } from "react-bootstrap";
import { FaRocket } from "react-icons/fa";
import { jsPDF } from "jspdf";

function HowItWorks() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/collaborate");
  };

  const eReceiptData = {
    merchant: {
      storeName: "TechStore Electronics",
      address: "123 Main St, Cityville, Country",
      phone: "+123 456 7890",
      website: "www.techstore.com",
    },
    transaction: {
      date: "2024-12-08",
      time: "14:45",
      items: [
        {
          name: "Laptop",
          quantity: 1,
          unitPrice: 999.99,
          totalPrice: 999.99,
        },
        {
          name: "Wireless Mouse",
          quantity: 1,
          unitPrice: 29.99,
          totalPrice: 29.99,
        },
      ],
      subtotal: 1029.98,
      tax: 51.5,
      totalAmount: 1081.48,
      paymentMethod: "Credit Card",
    },
    barcode: "12345678901234567890",
  };

  // Function to generate PDF
  const generatePDF = () => {
    const doc = new jsPDF();
    doc.setFont("Courier");
    doc.setFontSize(12);

    doc.text(`Store: ${eReceiptData.merchant.storeName}`, 10, 10);
    doc.text(`Address: ${eReceiptData.merchant.address}`, 10, 20);
    doc.text(`Phone: ${eReceiptData.merchant.phone}`, 10, 30);
    doc.text(`Website: ${eReceiptData.merchant.website}`, 10, 40);

    doc.text(`Date: ${eReceiptData.transaction.date}`, 10, 50);
    doc.text(`Time: ${eReceiptData.transaction.time}`, 10, 60);

    doc.text("Items Purchased:", 10, 70);
    let yPosition = 80;
    eReceiptData.transaction.items.forEach((item) => {
      doc.text(
        `${item.quantity} x ${item.name} @ ${item.unitPrice.toFixed(
          2
        )} = ${item.totalPrice.toFixed(2)}`,
        10,
        yPosition
      );
      yPosition += 10;
    });

    doc.text(
      `Subtotal: ${eReceiptData.transaction.subtotal.toFixed(2)}`,
      10,
      yPosition
    );
    doc.text(
      `Tax: ${eReceiptData.transaction.tax.toFixed(2)}`,
      10,
      yPosition + 10
    );
    doc.text(
      `Total: ${eReceiptData.transaction.totalAmount.toFixed(2)}`,
      10,
      yPosition + 20
    );
    doc.text(
      `Payment Method: ${eReceiptData.transaction.paymentMethod}`,
      10,
      yPosition + 30
    );

    // Barcode
    // doc.addImage(
    //   `https://barcode.tec-it.com/barcode.ashx?data=${eReceiptData.barcode}&code=Code128&translate-esc=true`,
    //   "PNG",
    //   10,
    //   yPosition + 50,
    //   50,
    //   20
    // );

    // var img1 = new Image();
    // img1.src =
    //   "https://barcode.tec-it.com/barcode.ashx?data=${eReceiptData.barcode}&code=Code128&translate-esc=true";
    // img1.onload = () => {
    //   // await for the image to be fully loaded
    //   doc.addImage(img1, "png", 10, yPosition + 50, 50, 20);
    //   doc.text("Sample", 20, 15);
    //   //...
    //   doc.save("receipt.pdf");
    // };

    doc.save("receipt.pdf");
  };

  // Function to share receipt via email (using the Web Share API)
  const shareReceipt = () => {
    const receiptText = `
      Receipt from ${eReceiptData.merchant.storeName}:
      Date: ${eReceiptData.transaction.date} Time: ${eReceiptData.transaction.time
      }
      Total: ${eReceiptData.transaction.totalAmount.toFixed(2)}
      Payment Method: ${eReceiptData.transaction.paymentMethod}
    `;

    if (navigator.share) {
      navigator
        .share({
          title: "E-Receipt from TechStore",
          text: receiptText,
          url: window.location.href,
        })
        .then(() => {
          console.log("Receipt shared successfully");
        })
        .catch((error) => {
          console.log("Error sharing receipt:", error);
        });
    } else {
      // Fallback for browsers that do not support Web Share API
      window.location.href = `mailto:?subject=TechStore Receipt&body=${encodeURIComponent(
        receiptText
      )}`;
    }
  };

  return (
    <div>
      {/* Banner Section */}

      <Container
        fluid
        className="hero-section text-center py-4"
      >
        <Row className="align-items-center">
          {/* Left Section - Text and Buttons */}
          <Col xs={12} md={6} className="text-center text-md-start">
            <p>
              <h1 className="banner-heading">Go Paperless with E-Receipts</h1>
              <br />
            </p>
            <p className="banner-subheading">
              Say goodbye to paper receipts and track your purchases easily on
              your phone. Experience the convenience of instant e-receipts with
              just a scan.
              <br />
            </p>
            <p>
              <br />
              <div className="d-flex flex-column flex-md-row gap-3">
                <Button
                  variant="success"
                  size="lg"
                  className="d-flex align-items-center justify-content-center"
                  onClick={handleGetStarted}
                >
                  <FaRocket size={25} />
                  <span className="ms-3">Collaborate with us</span>
                </Button>
              </div>
            </p>
          </Col>
          {/* Right Section - Image */}
          <Col xs={12} md={6} className="text-center">
            <Image
              src="mobile-receipt.png"
              className="img-fluid"
              alt="Hero Illustration"
              style={{ maxHeight: "50vh", objectFit: "contain" }}
            />
          </Col>
        </Row>
      </Container>
      <Container className="align-items-center py-4">
        <div className="text-center">
          <span className="highlight-text">E-RECEIPT Process</span>
        </div>
        <br />
        <Row>
          <Col md={4}>
            <Card>
              <Card.Header>
                <big>STEP 1</big>
              </Card.Header>
              <Card.Img
                variant="top"
                src="Checkout.png"
                className="howitworks justify-content-center howitworks-fadeIn"
              />
              <Card.Body>
                <Card.Title>Checkout at the POS</Card.Title>
                <Card.Text>
                  The process starts when you complete your purchase at the
                  Point of Sale (POS), which can be a retail store or any
                  merchant that supports e-receipt technology. At the checkout,
                  the cashier will prompt you with the option to receive your
                  receipt digitally.
                  <br /> If you are at a physical store, you will typically be
                  given the option to scan a QR code or enter your email
                  address. In online stores, your e-receipt is automatically
                  generated and emailed to you.
                  <br /> <b>Why it’s important:</b> This step eliminates the
                  need for paper receipts, helping reduce waste and making it
                  easier to track your purchases.
                  <br />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          {/* <Col md={1}>
            <div className="howitworks-arrow-container howitworks-fadeIn howitworks-delay1">
              <span className="howitworks-arrow">→</span>
            </div>
          </Col> */}
          <Col md={4}>
            <Card>
              <Card.Header>
                <big className="text-muted">STEP 2</big>
              </Card.Header>
              <Card.Img
                variant="top"
                src="ScanQr.png"
                className="howitworks justify-content-center  howitworks-fadeIn"
              />
              <Card.Body>
                <Card.Title>Scan the QR Code</Card.Title>
                <Card.Text>
                  At the checkout, you may be asked to scan a QR code using your
                  smartphone. This QR code is linked to the digital receipt
                  system, and once scanned, it triggers the e-receipt to be sent
                  directly to your mobile device. If you are at a physical
                  store, you will typically be given the option to scan a QR
                  code or enter your email address. In online stores, your
                  e-receipt is automatically generated and emailed to you.
                  <br /> <b>How it works:</b> By scanning the QR code, the
                  system captures your unique details (such as your email or
                  phone number) and securely sends the receipt to your device.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          {/* <Col md={1}>
            <div className="howitworks-arrow-container howitworks-fadeIn howitworks-delay1">
              <span className="howitworks-arrow">→</span>
            </div>
          </Col> */}
          <Col md={4}>
            <Card>
              <Card.Header>
                <big className="text-muted">STEP 3</big>
              </Card.Header>
              <Card.Img
                variant="top"
                src="receipt-image.png"
                className="howitworks justify-content-center howitworks-fadeIn"
              />
              <Card.Body>
                <Card.Title>Receive Your E-Receipt Instantly</Card.Title>
                <Card.Text>
                  Once the QR code is scanned or the email is entered, your
                  e-receipt will be delivered instantly to your phone, app, or
                  email. You can view and store the receipt digitally,
                  eliminating the need for paper storage.The e-receipt contains all the same information you’d
                  find on a paper receipt, such as:
                  <br />
                  <ul>
                    <li> <b>Merchant details (store name, location)</b></li>
                    <li><b>Date and time of the purchase</b></li>
                    <li><b>Itemized list of purchased products or services</b></li>
                    <li><b>Total amount paid</b></li>
                    <li><b>Payment method</b></li>
                  </ul>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Container fluid className="hero-section1">
        <Row>
          <Col xs={12} md={4} className="d-flex justify-content-center">
            <div className="phone-frame">
              <div className="phone-screen">
                {/* Receipt Card */}
                <Card className="receipt-card">
                  <Card.Body className="p-4 position-relative">
                    <div className="receipt-details">
                      <h3 className="text-center">TechStore Electronics</h3>
                      <p className="text-center">
                        123 Main St, Cityville, Country
                      </p>
                      <p className="text-center">Phone: +123 456 7890</p>
                      <p className="text-center">Website: www.techstore.com</p>

                      <div className="receipt-line"></div>

                      <p className="text-center">
                        <strong>Date:</strong> {eReceiptData.transaction.date}
                      </p>
                      <p className="text-center">
                        <strong>Time:</strong> {eReceiptData.transaction.time}
                      </p>

                      <div className="receipt-line"></div>

                      <h5>Items Purchased</h5>
                      <ul>
                        {eReceiptData.transaction.items.map((item, index) => (
                          <li key={index}>
                            {item.quantity} x {item.name} @ $
                            {item.unitPrice.toFixed(2)} = $
                            {item.totalPrice.toFixed(2)}
                          </li>
                        ))}
                      </ul>

                      <div className="receipt-line"></div>

                      <p>
                        <strong>Subtotal:</strong> $
                        {eReceiptData.transaction.subtotal.toFixed(2)}
                      </p>
                      <p>
                        <strong>Tax:</strong> $
                        {eReceiptData.transaction.tax.toFixed(2)}
                      </p>
                      <p>
                        <strong>Total:</strong> $
                        {eReceiptData.transaction.totalAmount.toFixed(2)}
                      </p>
                      <p>
                        <strong>Payment Method:</strong>{" "}
                        {eReceiptData.transaction.paymentMethod}
                      </p>

                      <div className="receipt-line"></div>

                      <div className="text-center">
                        <Image
                          src={`https://barcode.tec-it.com/barcode.ashx?data=${eReceiptData.barcode}&code=Code128&translate-esc=true`}
                          alt="Barcode"
                          className="barcode"
                        />
                      </div>

                      <div className="receipt-line"></div>
                      {/* Buttons for Actions */}
                      <div className="text-center">
                        <Button variant="primary" onClick={generatePDF}>
                          Download PDF
                        </Button>
                        <br />
                        <br />
                        <Button variant="secondary" onClick={shareReceipt}>
                          Share Receipt
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
              <div className="phone-buttons">
                <div className="phone-button"></div> {/* Left Button */}
                <div className="phone-button"></div> {/* Center Button */}
                <div className="phone-button"></div> {/* Right Button */}
              </div>
            </div>
          </Col>
          <Col md={8} className="justify-content-center">
            <div>
              <p>
                <h2>Key Advantages of E-Receipts</h2>
              </p>
              <p>
                E-receipts replace traditional paper receipts and can be stored
                electronically for easy access, reducing paper waste and
                enhancing convenience. E-receipts are more environmentally
                friendly, easier to store, and often can be easily retrieved or
                shared compared to paper receipts
              </p>
              <p>
                <b>Convenience:</b> Customers can store, search, and access
                receipts digitally.
              </p>
              <p>
                <b>Lower Operational Costs:</b> Businesses save money on paper,
                ink, and the maintenance of receipt printers. Additionally,
                fewer physical receipts reduce the cost of disposing of paper
                waste.
              </p>
              <p>
                <b>Efficient Workflow:</b> The process of sending e-receipts is
                automated and integrated into digital systems, which streamlines
                operations, reduces errors, and speeds up customer checkout.
              </p>
              <p>
                <b>Environmentally friendly:</b> Reduced paper waste.
              </p>
              <p>
                <b>Secure:</b> E-receipts are harder to lose compared to paper
                ones.
              </p>
              <p>
                <b>Easy Returns:</b> E-receipts simplify the process for returns
                or exchanges.
              </p>
              <p>
                <b>Tracking & Budgeting:</b> Easier for customers to track
                spending and manage finances.
              </p>
              <p>
                <b>Analytics:</b> Retailers can analyze the data from
                e-receipts, gaining insights into customer behavior, purchase
                patterns, and preferences, which can help improve marketing
                strategies and inventory management.
              </p>
              <p>
                E-receipts offer a blend of convenience, sustainability,
                cost-efficiency, and security, making them a preferred choice
                for both businesses and consumers in the digital age.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default HowItWorks;
